import { TMappedAnswersState } from '../types';

interface IParams {
  state: TMappedAnswersState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}

const excludedFieldKeys: Array<keyof TMappedAnswersState> = ['fullName', 'email', 'phone'];

/**
 * Утилита подготавливает набор лог-данных, исключая из ответов юзера персональные данные
 * */
export const prepareErrorMeta = ({ state, error }: IParams) => {
  const meta = {
    ...state,
    error,
  };

  excludedFieldKeys.forEach(key => {
    delete meta[key];
  });

  return meta;
};
